import React, { Suspense } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/home/HeroSection";
import { motion } from "framer-motion";
import ScrollIndicator from "@/components/ui/ScrollIndicator";

// Lazy load below-the-fold components
const Projects = React.lazy(() => import("@/components/home/ProjectsSection"));
const AboutUs = React.lazy(() => import("@/components/home/AboutUsSection"));
const Contact = React.lazy(() => import("@/components/home/ContactSection"));
const Footer = React.lazy(() => import("@/components/Footer"));
const ScanningSection = React.lazy(() => import("@/components/home/ScanningSection"));
const MarineSection = React.lazy(() => import("@/components/home/MarineSection"));
const ContainersSection = React.lazy(() => import("@/components/home/ContainersSection"));

// Fallback loader for lazy sections
const SectionLoader = () => (
  <div className="w-full min-h-[50vh] flex items-center justify-center bg-navy-dark">
    <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
  </div>
);

const Index = () => {
  return (
    <motion.div
      className="relative min-h-screen"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
    >
      <div className="fixed inset-0 -z-10 bg-navy-dark" aria-hidden />
      <ScrollIndicator />
      <Navbar />
      <main>
        {/* Hero section is critical for LCP, eager load it */}
        <Hero />

        {/* Suspense boundary for all lazy loaded below-the-fold content */}
        <Suspense fallback={<SectionLoader />}>
          <AboutUs />
          <MarineSection />
          <ContainersSection />
          <ScanningSection />
          <Projects />
          <Contact />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
    </motion.div>
  );
};

export default Index;

